// TODO: #649 refactor this. Make this similar to other actions (i.e. replace `payload` with original fields names).

export const types = {
  LOAD_USERS: {
    REQUEST: 'ADMIN.LOAD_USERS.REQUEST',
    RESPONSE: 'ADMIN.LOAD_USERS.RESPONSE',
  },
  CREATE_USER: {
    FIELD: 'ADMIN.CREATE_USER.FIELD',
    REQUEST: 'ADMIN.CREATE_USER.REQUEST',
    RESPONSE: 'ADMIN.CREATE_USER.RESPONSE',
  },
  DELETE_USER: {
    REQUEST: 'ADMIN.DELETE_USER.REQUEST',
    RESPONSE: 'ADMIN.DELETE_USER.RESPONSE',
  },
  EDIT_USER: {
    FIELD: 'ADMIN.EDIT_USER.FIELD',
    SHOW: 'ADMIN.EDIT_USER.SHOW',
    HIDE: 'ADMIN.EDIT_USER.HIDE',
    TOGGLE: 'ADMIN.EDIT_USER.TOGGLE',
    REQUEST: 'ADMIN.EDIT_USER.REQUEST',
    RESPONSE: 'ADMIN.EDIT_USER.RESPONSE',
  },
  PROCESS_PENDING_TRANSCRIPTS: 'PROCESS_PENDING_TRANSCRIPTS',
  GET_ADMIN_SETTINGS: 'GET_ADMIN_SETTINGS',
  UPDATE_ADMIN_SETTINGS: 'UPDATE_ADMIN_SETTINGS',
  CHANGE_ADMIN_SETTINGS: 'CHANGE_ADMIN_SETTINGS',
  FORCE_SYNC: {
    REQUEST: 'ADMIN.FORCE_SYNC.REQUEST',
    RESPONSE: 'ADMIN.FORCE_SYNC.RESPONSE',
  },
};

export const loadUsers = () => ({ type: types.LOAD_USERS.REQUEST });
export const loadUsersResponse = (users, error) => ({
  type: types.LOAD_USERS.RESPONSE,
  payload: users,
  error,
});

export const updateCreateUserField = (field, value) => ({
  type: types.CREATE_USER.FIELD,
  payload: { field, value },
});
export const createUser = () => ({ type: types.CREATE_USER.REQUEST });
export const createUserResponse = (error) => ({
  type: types.CREATE_USER.RESPONSE,
  error,
});

export const deleteUser = (userId) => ({
  type: types.DELETE_USER.REQUEST,
  payload: userId,
});
export const deleteUserResponse = (error) => ({
  type: types.DELETE_USER.RESPONSE,
  error,
});

export const updateSetUserPermissionField = (value) => ({
  type: types.EDIT_USER.FIELD,
  payload: value,
});

export const setUserPermission = () => ({ type: types.EDIT_USER.REQUEST });

export const setUserPermissionResponse = (error) => ({
  type: types.EDIT_USER.RESPONSE,
  error,
});
export const showEditUser = (userId) => ({
  type: types.EDIT_USER.SHOW,
  payload: userId,
});

export const hideEditUser = () => ({ type: types.EDIT_USER.HIDE });

export const toggleEditUser = (userId) => ({
  type: types.EDIT_USER.TOGGLE,
  payload: userId,
});

export const getAdminSettings = () => ({
  type: types.GET_ADMIN_SETTINGS,
});

export const updateAdminSettings = (settings) => ({
  type: types.UPDATE_ADMIN_SETTINGS,
  settings,
});

export const changeAdminSettings = ({ key, value, reason }) => ({
  type: types.CHANGE_ADMIN_SETTINGS,
  settings: { key, value, reason },
});

export const forceSyncRequest = () => ({
  type: types.FORCE_SYNC.REQUEST,
});

export const forceSyncResponce = () => ({
  type: types.FORCE_SYNC.RESPONSE,
});



// WEBPACK FOOTER //
// ./redux/actions/admin.js